import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'

import { config } from './wagmi'
import { AppProviders } from './AppProviders'
import { BaseRedirectGate } from './BaseRedirectGate'
import App from './App'

const queryClient = new QueryClient()

// Detectar se estamos no Base App
const isBaseApp = (window as any).__HOST__ === 'base' || document.documentElement.getAttribute('data-host') === 'base';

// Renderizar o App no elemento correto baseado no ambiente
// Base App usa 'react-root' (separado do HTML estático em 'app')
// Outros ambientes usam 'root'
const rootElement = isBaseApp ? 'react-root' : 'root';

// Marcar que React está pronto (mostrar conteúdo se for Mini App)
if (document.body) {
  document.body.classList.add('react-ready');
  document.documentElement.classList.add('react-ready');
}

// Verificar se o elemento root existe
const rootEl = document.getElementById(rootElement);
if (!rootEl) {
  console.error(`❌ Elemento #${rootElement} não encontrado!`);
  // Criar o elemento se não existir
  const newRoot = document.createElement('div');
  newRoot.id = rootElement;
  document.body.appendChild(newRoot);
  console.log(`✅ Elemento #${rootElement} criado`);
}

console.log('🚀 React iniciando renderização...');
console.log('📍 Pathname:', window.location.pathname);
console.log('🎨 Stylesheets:', Array.from(document.styleSheets).length);
console.log('🔍 isBaseApp:', isBaseApp);
console.log('🔍 __HOST__:', (window as any).__HOST__);
console.log('🔍 data-host:', document.documentElement.getAttribute('data-host'));
console.log('🔍 rootElement:', rootElement);

try {
  let rootEl = document.getElementById(rootElement);
  
  // NO BASE APP: Renderizar React em elemento separado (react-root)
  // O HTML estático permanece em #app, React renderiza em #react-root
  if (isBaseApp && rootElement === 'react-root') {
    console.log('✅ Base App: React renderizando em #react-root (HTML estático em #app)');
    // Garantir que o elemento react-root existe e está visível
    if (!rootEl) {
      const newRoot = document.createElement('div');
      newRoot.id = 'react-root';
      document.body.appendChild(newRoot);
      rootEl = newRoot;
      console.log('✅ Elemento #react-root criado');
    }
    rootEl.style.position = 'relative'; // Posicionar relativamente
    rootEl.style.zIndex = '1000'; // Garantir que modais apareçam por cima
  }
  
  if (!rootEl) {
    throw new Error(`Elemento #${rootElement} não encontrado!`);
  }
  
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              <Route path="*" element={
          <AppProviders>
            <BaseRedirectGate />
            <App />
          </AppProviders>
              } />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </WagmiProvider>
    </React.StrictMode>,
  )
  console.log('✅ React renderizado com sucesso!');
} catch (error) {
  console.error('❌ Erro ao renderizar React:', error);
  document.body.innerHTML = `
    <div style="padding: 2rem; font-family: monospace; color: red;">
      <h1>Erro ao carregar a aplicação</h1>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
      <pre>${error instanceof Error ? error.stack : ''}</pre>
    </div>
  `;
}
